import { LOAD_LAYOUT, UPDATE_LAYOUT } from './constants'

export const loadLayout = (layout) => ({ type: LOAD_LAYOUT, layout })
export const updateLayout = (layout) => ({ type: UPDATE_LAYOUT, layout })
